<template>
  <v-dialog v-model="userForm" no-click-animation persistent max-width="460">
    <v-card>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-title class="headline primary white--text">{{ dialogTitle }}</v-card-title>
        <v-card-text class="mt-20">
          <dynamic-form
            :watchKey="userForm"
            :fieldGroups="userFields"
            :bindObj="user"
            :split="false"
          />
        </v-card-text>
        <v-card-actions>
          <template v-if="operation === 'update'">
            <v-btn
              @click="generatePassword(user.id)"
              class="mx-2"
              title="Generate new password"
              color="primary"
              icon
              small
            >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-text-field
              @click:clear="clearGeneratedPassword"
              v-model="generatedPassword"
              style="max-width: 200px"
              label="New Password"
              clearable
              readonly
              solo
              dense
              hide-details
              v-if="generatedPassword && generatedPassword !== ''"
            />
          </template>

          <v-spacer></v-spacer>
          <v-btn @click="discard" class="white--text" color="primary" small depressed>
            Discard
          </v-btn>
          <v-btn
            @click="doSave"
            class="white--text"
            color="primary"
            :disabled="invalid || processing"
            small
            depressed
          >
            Save
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import { mapState, mapMutations, mapActions } from 'vuex';
import userFields from '@/models/user-fields';
import _ from 'lodash';

export default {
  name: 'UserForm',
  data() {
    return { oldUser: {}, processing: false };
  },
  computed: {
    ...mapState('user', ['operation', 'generatedPassword']),
    userFields() {
      // if (this.operation === 'update') {
      //   const passwordField = userFields[0].fields.find(f => f.name === 'password');
      //   passwordField.visible = false;
      // }
      return userFields;
    },
    userForm: {
      get: () => store.state.user.userForm,
      set: v => store.commit('user/setUserForm', v)
    },
    user: {
      get() {
        const { user } = store.state.user;
        if (this.operation === 'create') return user;
        return _.cloneDeep(user);
      },
      set: v => store.commit('user/setUser', v)
    },
    dialogTitle() {
      if (this.operation === 'create') return 'Create New User';
      return `Update User, ${this.user.email}`;
    }
  },
  methods: {
    ...mapMutations('user', ['toggleUserForm', 'clearGeneratedPassword']),
    ...mapActions('user', ['createUser', 'updateUser', 'generatePassword']),
    async doSave() {
      const { operation, user } = this;
      this.processing = true;
      if (operation === 'create') {
        await this.createUser(user);
      } else {
        await this.updateUser(user);
      }
      this.processing = false;
      this.$refs.observer.reset();
      this.oldUser = _.cloneDeep(this.user);
      this.toggleUserForm();
    },
    discard() {
      this.toggleUserForm();
      this.user = _.cloneDeep(this.oldUser);
      this.$refs.observer.reset();
    }
  },
  watch: {
    async userForm(n) {
      if (n) this.oldUser = _.cloneDeep(this.user);
    }
  }
};
</script>
